var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7337 2.26629C21.9807 2.51323 22.0643 2.87981 21.9489 3.20943L15.5853 21.3912C15.4622 21.743 15.1368 21.984 14.7643 21.9992C14.3919 22.0144 14.0479 21.8007 13.8965 21.4601L10.4022 13.5978L2.53988 10.1035C2.19926 9.95209 1.98557 9.60812 2.00076 9.23568C2.01595 8.86325 2.25696 8.53783 2.60878 8.41469L20.7906 2.05106C21.1202 1.93569 21.4868 2.01935 21.7337 2.26629ZM12.1752 13.1104L14.6267 18.6263L18.9168 6.36882L12.1752 13.1104ZM17.6312 5.08318L5.3737 9.37329L10.8896 11.8248L17.6312 5.08318Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentIcon);
export default __webpack_public_path__ + "static/media/SentIcon.d9bb291a74781dd0ef304faf7f90e9b8.svg";
export { ForwardRef as ReactComponent };